import React from 'react'

function AvisExamen() {
  return (
    <div className='messageriebox'>
        <p style={{fontSize:'30px',marginLeft:'10px',marginTop:'10px',fontWeight:'bold'}}>Avis d'examens</p>
        <hr/> 
       
      
    </div>
  )
}

export default AvisExamen